<template>
  <div class="layout" :class="{'layout_mobile': isMobile, 'layout_left-active': isMenuShifted}">
    <div class="layout__left" :class="{layout__left_active: isMenuShifted}">
      <div class="layout__menu">
        <div
          v-if="isMobile && !isMobileSmartTV"
          @click="CHANGE_SHIFT"
          class="layout__menu-burger">
            <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'layout__menu-burger-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        </div>

        <a href="https://buzzoola.com/ru/" class="layout__menu-logo-link">
          <img class="layout__menu-logo" alt='buzz logo' src='@/assets/logo.svg'>
        </a>

        <div class="layout__menu-nav">
          <div class="navigation">
            <router-link
              to="/mobile"
              class="navigation__link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20" v-bind:svg-inline="''" v-bind:class="'navigation__icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 1h4c2.2 0 4 1.8 4 4v10c0 2.2-1.8 4-4 4H5c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4z" fill="none" stroke="#000" stroke-width="1.7" stroke-miterlimit="10"/><path d="M6.3 15.6h1.5c.4 0 .7.1.7.4h0c0 .2-.3.4-.7.4H6.3c-.4 0-.7-.1-.7-.4h0c-.1-.2.2-.4.7-.4z" fill="none" stroke="#000" stroke-width="1.5" stroke-miterlimit="10"/></svg>
                <span class="navigation__text">Mobile</span>
            </router-link>
            <router-link
              v-if="!isMobile"
              to="/desktop"
              class="navigation__link">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" v-bind:svg-inline="''" v-bind:class="'navigation__icon navigation__icon_desk'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M5 1h10c2.2 0 4 1.8 4 4v5c0 2.2-1.8 4-4 4H5c-2.2 0-4-1.8-4-4V5c0-2.2 1.8-4 4-4z" fill="none" stroke="#000" stroke-width="1.7" stroke-miterlimit="10"/><path d="M7.5 16.5h5.1c.5 0 .8.2.8.5h0c0 .3-.3.5-.8.5H7.5c-.5 0-.8-.2-.8-.5h0c-.1-.3.3-.5.8-.5z" fill="none" stroke="#000" stroke-miterlimit="10"/></svg>
                <span class="navigation__text">Desktop</span>
            </router-link>
            <router-link
              to="/smarttv"
              class="navigation__link">
                <svg width="351" height="299" viewBox="0 0 351 299" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'navigation__icon navigation__icon_desk'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M141.169 277h69.854c6.848 0 10.957 2.739 10.957 6.848s-4.109 6.849-10.957 6.849h-69.854c-6.849 0-10.958-2.74-10.958-6.849-1.369-4.109 4.109-6.848 10.958-6.848z" stroke="#000" stroke-width="16" stroke-miterlimit="10"/><path d="M15 76v-1c0-33.137 26.863-60 60-60h201c33.137 0 60 26.863 60 60v98.5c0 33.137-26.863 60-60 60H168.5" stroke="#000" stroke-width="30" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.655 109.001c39.281-.218 117.845 24.355 117.845 124.393M15.655 158.758c22.696-.437 68.22 13.617 68.743 73.326M15 205.896c6.329 1.528 19.117 8.773 19.64 25.534" stroke="#000" stroke-width="27" stroke-linecap="round" stroke-linejoin="round"/></svg>
                <span class="navigation__text">SmartTV</span>
            </router-link>
          </div>
        </div>

        <div class="layout__menu-wrap">
          <main-menu @shift="CHANGE_SHIFT"/>
          <div class="layout__menu-btn-wrap">
            <router-link class="layout__menu-btn"
              :to="{
                name: 'Requirements',
                params: {id: 'mobile_native_unit'}
              }"
            >Документация</router-link>
            <div class="layout__menu-btn" @click="showPopup = !showPopup"> Связаться с нами</div>
          </div>
        </div>

      </div>
    </div>
    <div class="layout__right">
      <div class="main">
        <slot name="body"></slot>
      </div>
    </div>

    <feedback v-show="showPopup" :showPopup="showPopup" @hidePopup="hidePopup"></feedback>
  </div>
</template>

<script>
import feedback from '@/components/feedback.vue';
import mainMenu from '@/components/mainMenu.vue';
import { isMobile } from 'mobile-device-detect';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'layout',
  components: {
    mainMenu,
    feedback,
  },
  props: {},
  data() {
    return {
      isMobile,
      isUniversal: false,
      showPopup: false,
    };
  },
  computed: {
    ...mapGetters([
      'isMenuShifted',
    ]),
    isMobileSmartTV() {
      return this.isMobile && this.$router.currentRoute.name === 'SmartTV';
    },
  },
  methods: {
    ...mapMutations([
      'CHANGE_SHIFT',
    ]),
    hidePopup() {
      this.showPopup = !this.showPopup;
    },
  },
  watch: {
    isMobileSmartTV: {
      handler() {
        this.CHANGE_SHIFT(true);
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang='stylus'>
hover()
  @media (hover: hover)
    {block}

.layout
  position absolute
  left 0
  top 0
  width 100%
  height 100%
  display flex
  align-items stretch
  &_mobile&_left-active
    overflow hidden
  &__right
    width 100%
    max-height 100%
    overflow auto
    ^[0]_mobile &
      max-height none
      overflow unset
  &__left
    position relative
    flex-shrink 0
    width 360px
    height 100%
    padding 20px
    box-sizing border-box
    background-color white
    transition transform .2s ease-in-out
    ^[0]_mobile &
      position absolute
      z-index 9999999999
      width 100%
      transform translateX(-100%)
      padding 15px 20px 20px
      &_active
        transform translateX(0)
  &__menu
    height 100%
    &-wrap
      height calc(100% - 280px)
      ^[0]_mobile &
        height calc(100% - 230px)
    &-btn-wrap
      position absolute
      bottom 10px
      left 20px
      width 320px
      display flex
      align-items center
      flex-direction column
      ^[0]_mobile &
        width calc(100% - 40px)
    &-btn
      width 100%
      margin-top 10px
      padding 12px
      text-align center
      text-decoration none
      font-size 14px
      line-height 16px
      font-family 'Roboto', sans-serif
      font-weight 500
      color #f50
      border-radius 8px
      border 1px solid #cfdae6
      box-sizing border-box
      -webkit-tap-highlight-color transparent
      text-decoration none
      +hover()
        &:hover
          background-color #f50
          color #fff
          cursor pointer
          border 1px solid #f50
    &-logo
      width 170px
      height auto
      display block
      text-decoration none
      outline none
      border none
      ^[0]_mobile &
        width 130px
        margin 0 auto 30px
      &-link
        text-decoration none
        outline none
        border none
    &-burger
      position absolute
      left 20px
      top 20px
      z-index 2
      width 20px
      height 20px
      -webkit-tap-highlight-color transparent
      outline none
      &-icon
        width 100%
        height 100%
        fill #f50
        -webkit-tap-highlight-color transparent
        outline none

.navigation
  width 100%
  margin 40px 0 20px
  text-align center
  &__link
    display inline-block
    width 50%
    height 40px
    box-sizing border-box
    text-decoration none
    border-radius 8px
    text-align center
    &:before
      content ''
      display inline-block
      width 0
      height 100%
      vertical-align middle
    &.router-link-active
      background-color #F5F7FA
      cursor default
  &__text
    display inline-block
    font-size 14px
    line-height 14px
    font-family 'Roboto', sans-serif
    font-weight 500
    color black
    vertical-align middle
    .router-link-active &
      color #FF5500
  &__icon
    display inline-block
    width 14px
    height auto
    margin-right 8px
    vertical-align middle
    stroke #000
    pointer-events none
    &_desk
      width 20px
    .router-link-active & path
      stroke #FF5500
    .router-link-active & rect
      stroke #FF5500
</style>
